// // Table Helpers are the functions to reuse common table functions

// /**
//  *
//  * @param {number} currentSize
//  */

// export function setTableSize(currentSize) {}

// /**
//  *
//  * @param {number} currentPage
//  */

// export function changePage(currentPage) {}

/**
 * @param {Array} columns
 */

export function tableSort({ columns, item }) {
  let sortBy;
  let sortOrder;
  columns.forEach(ele => {
    if (!item.sortOrder) {
      ele.sortOrder = '';
    }
  });
  sortBy = item.field;
  if (item.sortOrder === '' || item.sortOrder === 'DESC') {
    sortOrder = 'ASC';
    item.sortOrder = 'ASC';
  } else {
    sortOrder = 'DESC';
    item.sortOrder = 'DESC';
  }
  return { sortOrder, sortBy };
}
/**
 *
 * @param status checkbox status
 * @param selectedItems selected items array where id will be pushed
 * @param data for data
 * @param key which key you want to push to selectedItems
 */
export function selectAll({ status, data, key }) {
  let selectedItems = [];

  if (status) {
    data.forEach(element => {
      selectedItems.push(element[key]);
    });
  }
  return selectedItems;
}

/**
 * To get columns after applying sorting
 *
 * @param columns
 * @param sortBy
 * @param sortOrder
 *
 * @return sortedColumns
 */
export function getSortedColumns(columns, sortBy, sortOrder) {
  return columns.map(column => {
    if (sortBy === column.field) {
      column.sortOrder = sortOrder || '';
    } else {
      column.sortOrder = '';
    }
    return column;
  });
}

/** CONSTANTS **/
const pageSizes = {
  OPTION_1: [
    {
      val: 20,
      label: '20 entries'
    },
    {
      val: 50,
      label: '50 entries'
    },
    {
      val: 100,
      label: '100 entries'
    },
    {
      val: 150,
      label: '150 entries'
    }
  ],
  OPTION_2: [
    {
      val: 5,
      label: '5 entries'
    },
    {
      val: 10,
      label: '10 entries'
    },
    {
      val: 15,
      label: '15 entries'
    },
    {
      val: 20,
      label: '20 entries'
    }
  ]
};
const tableItems = {
  subject: {
    label: 'Subject',
    field: 'subject',
    sortable: true
  },
  sender: {
    label: 'Sender',
    field: 'from',
    sortable: true
  },
  recipient: {
    label: 'Recipient',
    field: 'recipient',
    sortable: false
  },
  dateTime: {
    label: 'Date & Time',
    field: 'date',
    sortable: true,
    sortOrder: 'DESC'
  },
  fileName: {
    label: 'File name',
    field: 'fileName',
    sortable: true
  },
  size: {
    label: 'Size',
    field: 'fileSize',
    sortable: true
  },
  accessibleBy: {
    label: 'Accessible by',
    field: 'owner',
    sortable: false
  },
  id: { label: 'ID' },
  subscrptionId: { label: 'Sub. ID' },
  transactionId: { label: 'Transaction ID' },
  subscriber: {},
  memo: { label: 'Memo' },
  paymentType: { label: 'Payment Type' },

  amount: { label: 'Amount' },
  createdAt: {
    label: 'Created at',
    field: 'createdOn',
    sortable: true
  },
  syncedAt: {
    label: 'Synced at',
    field: 'updatedOn',
    sortable: true,
    sortOrder: 'DESC'
  },
  version: {
    label: 'Version',
    field: 'version',
    sortable: true
  },
  name: {
    label: 'Name',
    field: 'name',
    sortable: true,
    sortOrder: 'ASC'
  },

  emailAddress: {
    label: 'Email address',
    field: 'email',
    html: true
  },
  status: {
    label: 'Status',
    field: 'status',
    sortable: true
  },
  role: {
    label: 'Role',
    field: 'role[0]',
    sortable: false
  },
  license: {
    label: 'License',
    field: 'license',
    sortable: true
  },
  logId: {
    label: 'LogId',
    field: 'id'
  },
  source: {
    label: 'Source',
    field: 'source',
    sortable: true
  },
  event: {
    label: 'Event',
    field: 'logType',
    sortable: true
  },
  details: {
    label: 'Details',
    field: 'objectId'
  },
  account: {
    label: 'Account',
    field: 'userId'
  },
  approvedBy: {
    label: 'Approved/ Reviewed By',
    field: 'approvedBy'
  },
  projectName: {
    label: 'Project Name',
    field: 'projectName',
    sortable: true
  },
  type: {
    label: 'Type',
    field: 'projectType',
    sortable: true
  },

  updatedAt: {
    label: 'Updated at',
    field: 'lastUpdated'
  },
  owner: {
    label: 'Owner',
    field: 'owner'
  },
  collaborators: {
    label: 'Collaborators',
    field: 'collaborators'
  },
  savedItems: {
    label: 'Saved Items',
    field: 'savedItems'
  },
  whiteListed: {
    label: 'Whitelisted Items',
    field: 'whitelistitems'
  },
  blank: {
    label: '',
    field: ''
  },
  blackListed: {
    label: 'Blacklisted Items',
    field: 'whitelistitems'
  },
  action: {
    label: 'Action',
    field: 'action'
  },
  Type: {
    label: 'Type',
    field: 'type'
  },
  email: {
    label: 'Email',
    field: 'email'
  },
  sourceType: {
    label: 'Type',
    field: 'sourceType',
    sortable: false
  },
  tags: {
    label: 'Top Tags',
    field: 'tags',
    sortable: false
  }
};

// only add a table column if it is used more than twice in the project
// If not yet get it from getCustomTableColumn

const tableColumns = {
  email: [
    { ...tableItems.subject, width: '25%' },
    { ...tableItems.sender, width: '25%' },
    { ...tableItems.recipient, width: '25%' },
    { ...tableItems.dateTime, width: '25%' }
  ],
  projectArchivedEmail: [
    { ...tableItems.subject, width: '20%' },
    { ...tableItems.sender, width: '20%' },
    { ...tableItems.recipient, width: '20%' },
    { ...tableItems.dateTime, width: '20%' },
    { ...tableItems.tags, width: '15%' }
  ],
  vault: [
    { ...tableItems.fileName, width: '20%' },
    { ...tableItems.size, width: '15%' },
    { ...tableItems.sourceType, width: '10%' },
    { ...tableItems.accessibleBy, width: '20%' },
    { ...tableItems.createdAt, width: '20%' },
    { ...tableItems.syncedAt, width: '20%' },
    { ...tableItems.version, width: '20%' }
  ],
  projectArchivedvault: [
    { ...tableItems.fileName, width: '20%' },
    { ...tableItems.size, width: '15%' },
    { ...tableItems.sourceType, width: '10%' },
    { ...tableItems.accessibleBy, width: '20%' },
    { ...tableItems.createdAt, width: '15%' },
    { ...tableItems.syncedAt, width: '15%' },
    { ...tableItems.version, width: '15%' },
    { ...tableItems.tags, width: '15%' }
  ],
  users: [
    { ...tableItems.name, width: '20%' },
    { ...tableItems.emailAddress, width: '25%' },
    { ...tableItems.status, width: '15%' },
    { ...tableItems.role, width: '25%' },
    { ...tableItems.license, width: '15%' }
  ],
  audit: [
    { ...tableItems.logId, width: '15%' },
    { ...tableItems.source, width: '15%' },
    { ...tableItems.event, width: '15%' },
    { ...tableItems.details, width: '25%' },
    { ...tableItems.account, width: '15%' },
    { ...tableItems.dateTime, width: '15%' }
  ],
  discovery: [
    { ...tableItems.approvedBy, width: '20%' },
    { ...tableItems.projectName, width: '20%' },
    { ...tableItems.type, width: '15%' },
    { ...tableItems.createdAt, width: '20%' },
    { ...tableItems.updatedAt, width: '15%' },
    { ...tableItems.owner, width: '20%' }
  ],
  payments: [
    { ...tableItems.transactionId, width: '15%' },
    { ...tableItems.paymentType, width: '15%' },
    { ...tableItems.memo, width: '25%' },
    { ...tableItems.amount, width: '15%' },
    { ...tableItems.dateTime, width: '15%' },
    { ...tableItems.status, width: '15%' }
  ],
  teams: [
    { ...tableItems.name, width: '30%' },
    { ...tableItems.accessibleBy, width: '25%' },
    { ...tableItems.createdAt, width: '20%' },
    { ...tableItems.syncedAt, width: '20%' }
  ]
};
/**
 *
 * @param {string} id
 */
export function getTableColumns(id) {
  return tableColumns[id];
}

export function getPageSizeList(option) {
  return pageSizes[option];
}
/**
 *
 * @param {Array<string>} ids
 */

export function getCustomTableColumn(ids) {
  const customTableColumns = [];
  ids.forEach(id => {
    customTableColumns.push(tableItems[id]);
  });
  return customTableColumns;
}

export const defaultEmailSearchParams = {
  advanceSearchParams: {
    attachments: [],
    endDate: 0,
    fromEmail: [],
    hasAttachments: false,
    hasWords: [],
    ownerId: '',
    searchScope: 'all',
    startDate: 0,
    subject: [],
    toEmail: []
  },
  tableProps: {
    pageSize: pageSizes.OPTION_1[0].val,
    pageNumber: 1,
    sortBy: 'date',
    sortOrder: 'DESC'
  }
};

export const defaultTableProps = {
  pageSize: pageSizes.OPTION_1[0].val,
  pageNumber: 1,
  sortBy: 'updatedOn',
  sortOrder: 'DESC'
};
